import { cn } from "@/lib/utils";

// Standard section wrapper with generous vertical rhythm and container.
export const Section = ({
  children,
  className = "",
  containerClassName = "",
  id,
  as: Tag = "section",
  ...rest
}) => (
  <Tag
    id={id}
    className={cn("py-24 md:py-32 lg:py-40 relative", className)}
    {...rest}
  >
    <div className={cn("max-w-7xl mx-auto px-6 md:px-12", containerClassName)}>
      {children}
    </div>
  </Tag>
);

// Eyebrow + heading + optional lead paragraph. Left-aligned by default.
export const SectionHeading = ({
  eyebrow,
  title,
  lead,
  align = "left",
  tone = "dark",
  className = "",
  as = "h2",
}) => {
  const Heading = as;
  const isLight = tone === "light";
  return (
    <div
      className={cn(
        "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className
      )}
    >
      {eyebrow && (
        <p
          className={cn(
            "text-xs md:text-sm tracking-[0.25em] uppercase font-medium mb-5",
            isLight ? "text-legacy-gold" : "text-legacy-mint"
          )}
        >
          {eyebrow}
        </p>
      )}
      <Heading
        className={cn(
          "font-heading text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight",
          isLight ? "text-legacy-charcoal" : "text-white"
        )}
      >
        {title}
      </Heading>
      {lead && (
        <p
          className={cn(
            "mt-6 text-lg md:text-xl leading-relaxed",
            isLight ? "text-legacy-charcoal/70" : "text-white/70"
          )}
        >
          {lead}
        </p>
      )}
    </div>
  );
};
